import React from "react";
import { Spinner } from "react-bootstrap";

function TabsContentLoader() {
  return (
    <div
      style={{
        minHeight: "800px",
        justifyContent: "center",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Spinner animation="border" variant="danger" />
    </div>
  );
}

export default TabsContentLoader;
